import type { ReactElement } from 'react'

import Linkify from 'linkify-react'

const linkOptions = {
  target: '_blank',
  rel: 'noopener noreferrer',
}

export const formatComment = (comment: string): ReactElement => {
  return <Linkify options={linkOptions}>{comment}</Linkify>
}

export function useFormatComment() {
  return (comment: string): ReactElement => {
    return formatComment(comment)
  }
}
